module.exports = __webpack_public_path__ + "img/cast_resources_footer.8133430d.png";